import { Component, Input } from '@angular/core';

@Component({
  selector: 'ap-errors',
  templateUrl: 'errors.component.html'
})
export class ErrorsComponent {

  @Input() errors: string[];

}